export type Sizes = 'small' | 'medium' | 'large';

export default {
  small: 4,
  medium: 6,
  large: 9,
} as Record<Sizes, number>;
